import { Navigate, useParams } from 'react-router-dom';

/** Redirect legacy camp group detail URLs to the flat lessons browse page. */
export function LegacyCampGroupRedirect() {
  const { academySlug } = useParams<{ academySlug: string }>();
  if (!academySlug) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={`/academy/${academySlug}/lessons`} replace />;
}

/** Subdomain host: `/lessons/camps/:groupId` → `/lessons`. */
export function LegacyCampGroupSubdomainRedirect() {
  return <Navigate to="/lessons" replace />;
}
